<template>
  <v-card-list :title="title" title-color="teal">
    <!-- Messages to show when there is no content to show -->
    <v-mapping-list-messages />
    <!-- The input to write a custom mapped value -->
    <v-mapping-list-input />
    <!-- The values of the mapped item selected if the app is showing the mapped values -->
    <v-mapping-list-values />
    <!-- Similar mapped values -->
    <v-mapping-list-similar />
    <!-- Values without mapping that could map to the selected value too -->
  </v-card-list>
</template>

<script>
import { mapState } from "vuex";
import VCardList from "./CardList";
import VMappingListInput from "./MappingListInput";
import VMappingListMessages from "./MappingListMessages";
import VMappingListSimilar from "./MappingListSimilar";
import VMappingListValues from "./MappingListValues";

export default {
  components: {
    VCardList,
    VMappingListInput,
    VMappingListMessages,
    VMappingListSimilar,
    VMappingListValues
  },
  computed: {
    ...mapState("valueMapping", ["activeMappedItem", "showingMappedValues"]),
    /**
     * The title to show in the card according to the active value.
     */
    title() {
      if (!this.activeMappedItem) return "Mapeo de valores";
      if (this.showingMappedValues) {
        return `Mapear todos los "${this.activeMappedItem.mapped}"`;
      } else {
        return `Mapear "${this.activeMappedItem.value}"`;
      }
    }
  }
};
</script>